import { Unity, useUnityContext } from "react-unity-webgl";

function DemoGame() {
  const { unityProvider, isLoaded, loadingProgression, requestFullscreen } = useUnityContext({
    loaderUrl:     "/demo_build/Demo0_7_Web.loader.js",
    dataUrl:       "/demo_build/Demo0_7_Web.data",
    frameworkUrl:  "/demo_build/Demo0_7_Web.framework.js",
    codeUrl:       "/demo_build/Demo0_7_Web.wasm",
  });

  return (
    <div style={{ width: "960px", margin: "0 auto", position: "relative" }}>
      {!isLoaded && (
        <div style={{
          position: "absolute",
          top: 0, left: 0,
          width: "960px", height: "600px",
          display: "flex", alignItems: "center", justifyContent: "center",
          background: "#000", color: "#fff", zIndex: 1
        }}>
          Loading... {Math.round(loadingProgression * 100)}%
        </div>
      )}
      <Unity
        unityProvider={unityProvider}
        style={{ width: "960px", height: "600px" }}
      />
      <button style={{color: '#fff', backgroundColor: '#4b7c9e', float: "right"}} onClick={() => requestFullscreen(true)}>Fullscreen</button>

    </div>
  );
}

export default DemoGame;